const Malayalam = {
  // COMMON
  language: "ഭാഷ",
  changeLanguage: "ഭാഷ മാറ്റുക",
  date: "തീയതി",
  time: "സമയം",
  price: "വില",
  month: "മാസം",
  nearbyTemples: "അടുത്തുള്ള ക്ഷേത്രങ്ങൾ",
  createTemples: "ക്ഷേത്രങ്ങൾ സൃഷ്ടിക്കുക",
  temples: "ക്ഷേത്രങ്ങൾ",
  latestTemples: "പുതിയ ക്ഷേത്രങ്ങൾ",
  groupOfTemples: "ക്ഷേത്രങ്ങളുടെ സംഘം",

  //DASHBOARD
  templeCreateDescription:
    "ഒരു ക്ഷേത്ര പ്രൊഫൈൽ സൃഷ്ടിക്കുന്നത് ലളിതവും അർത്ഥപൂർണ്ണവും സൗജന്യവുമാണ്. നിങ്ങളുടെ ക്ഷേത്രത്തിന്റെ കഥ മറ്റുള്ളവർക്ക് പ്രചോദനമാകട്ടെ, വളരുന്ന ആത്മീയ നെറ്റ്വർക്കിന്റെ ഭാഗമാകൂ.",

  backToSearch: "തിരച്ചിലിലേക്ക് മടങ്ങുക",
  backToDashboard: "ഡാഷ്ബോർഡിലേക്ക് മടങ്ങുക",
  templeView: "ക്ഷേത്ര ദൃശ്യം",
  editTemples: "ക്ഷേത്രങ്ങൾ തിരുത്തുക",
  backToTemples: "ക്ഷേത്രങ്ങളിലേക്ക് മടങ്ങുക",
  profile: "പ്രൊഫൈൽ",
  personalInfo: "വ്യക്തിഗത വിവരം",
  locationBackground: "സ്ഥാനം & പശ്ചാത്തലം",
  spiritualIdentification: "ആത്മീയത & തിരിച്ചറിയൽ",
  editProfile: "പ്രൊഫൈൽ തിരുത്തുക",
  profilePhoto: "പ്രൊഫൈൽ ഫോട്ടോ",
  backToProfile: "പ്രൊഫൈലിലേക്ക് മടങ്ങുക",
  saveProfile: "പ്രൊഫൈൽ സംരക്ഷിക്കുക",
  optional: "(ഐച്ഛികം)",

  // TEMPLE
  templeGallery: "ക്ഷേത്ര ഗാലറി",
  mainDeity: "പ്രധാന ദേവൻ",
  otherDeity: "മറ്റ് ദേവന്മാർ",
  location: "സ്ഥലം",
  address: "വിലാസം",
  city: "നഗരം",
  district: "ജില്ല",
  state: "സംസ്ഥാനം",
  country:"രാജ്യം",
  pincode: "പിൻകോഡ്",
  geographicCoordinates: "ഭൗഗോളിക സഹവർത്തിത്വങ്ങൾ",
  cityTownVillage: "നഗരം / പട്ടണം / ഗ്രാമം",

  availableFacilities: "ലഭ്യമായ സൗകര്യങ്ങളും പ്രവേശനവും",
  ritualsGuidelines: "ആചാര മാർഗ്ഗനിർദ്ദേശങ്ങൾ",
  dressCode: "വസ്ത്രധാരണമുറ",
  festivalEvents: "ഉത്സവങ്ങളും ഇവന്റുകളും",
  poojaDetails: "പൂജാ വിശദാംശങ്ങൾ",
  contactInfo: "ബന്ധപ്പെടേണ്ട വിവരം",
  templeTimings: "ക്ഷേത്ര സമയങ്ങൾ",
  morning: "രാവിലെ",
  afternoon: "ഉച്ചക്ക്",
  sthalaVirutcham: "സ്ഥലവൃക്ഷം",
  bestTime: "സന്ദർശിക്കാൻ ഏറ്റവും നല്ല സമയം",
  atonementRituals: "ഈ ക്ഷേത്രത്തിലെ പ്രായശ്ചിത്ത ആചാരങ്ങൾ",
  howToReach: "എങ്ങനെ എത്തിച്ചേരാം",
  km: "കി.മീ",
  ownershipDetails: "ക്ഷേത്ര ഉടമസ്ഥാവകാശ വിവരം",
  managedBy: "നിയന്ത്രിക്കുന്നത്",

  //TEMPLE CONTACT
  templeEmail: "ക്ഷേത്രത്തിന്റെ ഇമെയിൽ വിലാസം",
  templeOwnershipContact: "ക്ഷേത്ര ഉടമസ്ഥാവകാശ കോൺടാക്ട് വിവരം",
  otherContactInfo: "മറ്റു കോൺടാക്ട് വിവരം",

  // REVIEWS
  reviews: "അവലോകനങ്ങൾ",
  communityReviews: "ഞങ്ങളുടെ സമൂഹത്തിൽ നിന്ന് അവലോകനങ്ങൾ",
  searchReviews: "അവലോകനങ്ങൾ തിരയുക",
  reviewDetails: "അവലോകന വിശദാംശങ്ങൾ",
  review: "അവലോകനം",
  noReviews: "നിങ്ങളുടെ ക്ഷേത്രാനുഭവം പങ്കുവെക്കുന്ന ആദ്യ വ്യക്തിയാവൂ.",

  // EXPERIENCES
  userExperience: "അനുഭവങ്ങൾ",
  shareYourExperience: "നിങ്ങളുടെ അനുഭവം പങ്കിടുക",
  communityExperiences: "ഞങ്ങളുടെ സമൂഹത്തിലെ അനുഭവങ്ങൾ",
  searchExperiences: "അനുഭവങ്ങൾ തിരയുക",
  experienceDetails: "അനുഭവ വിശദാംശങ്ങൾ",
  search: "തിരയുക",

  // SUGGESTIONS
  suggestUpdate: "ഒരു അപ്ഡേറ്റ് നിർദ്ദേശിക്കുക",
  helpImprove1: "ഞങ്ങൾ മറന്നുപോയ എന്തെങ്കിലും കാര്യങ്ങൾ നിങ്ങൾക്ക് അറിയാമോ",
  helpImprove2:
    "വിവരങ്ങൾ കൃത്യമായും പുതുക്കപ്പെട്ടതുമാക്കാൻ നിങ്ങളുടെ നിർദ്ദേശങ്ങൾ പങ്കിടുക.",
  suggestion: "നിർദ്ദേശം",
  referenceLink: "റഫറൻസ് ലിങ്ക്",
  otherGroupTemples: "ഈ ഗ്രൂപ്പിലെ മറ്റ് ക്ഷേത്രങ്ങൾ",

  // BUTTONS
  viewAllTemples: "എല്ലാ ക്ഷേത്രങ്ങളും കാണുക",
  getDirection: "ദിശകൾ നേടുക",
  website: "ക്ഷേത്ര വെബ്സൈറ്റ്",
  writeReview: "ഒരു അവലോകനം എഴുതുക",
  addSuggestion: "നിർദ്ദേശം ചേർക്കുക",
  next: "അടുത്തത്",
  previous: "മുമ്പത്തെ",
  cancel: "റദ്ദാക്കുക",
  submit: "സമർപ്പിക്കുക",
  updatePassword: "പാസ്‌വേഡ് അപ്ഡേറ്റ് ചെയ്യുക",
  updateNow: "ഇപ്പോൾ അപ്ഡേറ്റ് ചെയ്യുക",

  // INPUT
  name: "പേര്",
  phoneNumber: "ഫോൺ നമ്പർ",
 mobileNumber:"മൊബൈൽ നമ്പർ",
// menus
  dashboard: "ഡാഷ്ബോർഡ്",
  admission: "പ്രവേശനം",
  report: "റിപ്പോർട്ട്",
  timeTable: "സമയപ്പട്ടിക",
  messaging: "സന്ദേശങ്ങൾ",
  events: "ഇവന്റുകൾ",
  master: "മാസ്റ്റർ",
  exam: "പരീക്ഷ",
  download: "ഡൗൺലോഡ്",
  attendanceDashboard: "ഹാജർ ഡാഷ്ബോർഡ്",
  // PROFILE
  currentPassword: "നിലവിലെ പാസ്‌വേഡ്",
  newPassword: "പുതിയ പാസ്‌വേഡ്",
  confirmNewPassword: "പുതിയ പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക",
  firstName: "ആദ്യ പേര്",
  middleName:"മധ്യനാമം",
  lastName: "അവസാന പേര്",
  fullName: "പൂർണ്ണ പേര്",
  fatherName:"അച്ഛന്റെ പേര്",
   motherName:"അമ്മയുടെ പേര്",
  dateOfBirth: "ജനന തീയതി",
  age: "പ്രായം",
  gender: "ലിംഗം",
  email: "ഇമെയിൽ വിലാസം",
  phone: "ഫോൺ നമ്പർ",
  bio: "ജീവചരിത്രം",
  religion: "മതം",
  visitFrequency: "സന്ദർശന ആവൃത്തി",
  maritalStatus: "വൈവാഹിക സ്ഥിതി",
  aadhaarNumber: "ആധാർ നമ്പർ",
  panNumber:"പാൻ നമ്പർ",
  passportNumber: "പാസ്പോർട്ട് നമ്പർ",
  occupation: "തൊഴിൽ",
  bloodGroup: "രക്ത ഗ്രൂപ്പ്",

  // EMPTY
  noGuidelines: "ആചാര മാർഗ്ഗനിർദ്ദേശങ്ങൾ ലഭ്യമല്ല.",
  noDressCode: "വസ്ത്രധാരണമുറ സംബന്ധിച്ച വിവരങ്ങൾ ലഭ്യമല്ല.",
  noAtonementRituals: "ഈ ക്ഷേത്രത്തിൽ പ്രായശ്ചിത്ത ആചാരങ്ങൾ ഇല്ല.",
  noTransport: "അടുത്തുള്ള ഗതാഗത സൗകര്യങ്ങൾ ലഭ്യമല്ല.",
  noFestivalEvents: "ഉത്സവം അല്ലെങ്കിൽ ഇവന്റ് ഡാറ്റ ലഭ്യമല്ല",
  noPoojaData: "പൂജാ ഡാറ്റ ലഭ്യമല്ല",
  noOwnershipData: "ഉടമസ്ഥാവകാശ ഡാറ്റ ലഭ്യമല്ല",
  noContactData: "കോൺടാക്ട് ഡാറ്റ ലഭ്യമല്ല",
  noTempleImages: "ക്ഷേത്ര ചിത്രങ്ങൾ ലഭ്യമല്ല.",

  // COMMON
  shareTemple: "ഈ ക്ഷേത്രം പങ്കിടുക",
  copied: "പകർത്തി!",
  note: "കുറിപ്പ്:",
  passwordNote:
    "നിങ്ങളുടെ പാസ്‌വേഡ് വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തതിന് ശേഷം, സുരക്ഷാ കാരണങ്ങളാൽ നിങ്ങളെ സ്വയമേവ ലോഗിൻ പേജിലേക്ക് തിരിച്ചുവിടും. തുടർന്നുനടത്താൻ ദയവായി നിങ്ങളുടെ പുതിയ പാസ്‌വേഡ് ഉപയോഗിച്ച് സൈൻ ഇൻ ചെയ്യുക.",
};
export default Malayalam;
